/*
 * Moves the product trust panel below the buy button on mobile.
 *
 * The panel is rendered inside .product__media-wrapper so that on desktop it
 * sits directly under the photo and levels the two columns (see section 35 of
 * skincare-club-match.css for why it cannot be a third flex item).
 *
 * That nesting has a cost on mobile: Dawn stacks the media column first, so the
 * panel landed between the photo and the product title - reassurance shown
 * before the customer knows what the product is or what it costs. Measured at
 * 390px: image 182, panel 560, title 753, price 820, Add to basket 1144.
 *
 * CSS cannot fix it. `order` only reorders siblings, and the panel is a child
 * of the media column rather than a sibling of it, so there is no rule that
 * moves it past the info column. Rendering it twice and hiding one copy would
 * duplicate the Trustpilot embed. Relocating the single node is the cheapest
 * correct option.
 *
 * Runs on load and on resize, and is idempotent - it only touches the DOM when
 * the panel is not already in the right place.
 *
 * The mobile anchor is the LAST of the two buy-side blocks - Add to basket, and
 * Add to wishlist where the app has one. Anchoring on the basket button alone
 * dropped the 187px panel between the two buttons, which reads as the end of
 * the page and pushes the wishlist out of the same glance.
 */
(function () {
  'use strict';

  var BREAKPOINT = 990;

  // Walk up to whichever ancestor is a direct child of the info container, so
  // the panel is inserted between blocks rather than inside one.
  function blockOf(el, container) {
    if (!el) return null;
    var node = el;
    while (node.parentElement && node.parentElement !== container) {
      node = node.parentElement;
    }
    return node.parentElement === container ? node : null;
  }

  function infoAnchor() {
    var container = document.querySelector('.product__info-container');
    if (!container) return null;

    // The buy-buttons block renders a .product-form; Wishlist Hero's block
    // renders its own container. Either may be absent - the wishlist button is
    // an app block that can be removed in the theme editor, and the app can be
    // uninstalled - so the anchor is whichever of the two comes last.
    var buy = blockOf(container.querySelector('.product-form'), container);
    var wishlist = blockOf(
      container.querySelector('[class*="wishlisthero"], [class*="wishlist-hero"]'),
      container
    );

    if (buy && wishlist) {
      var wishlistIsLater =
        buy.compareDocumentPosition(wishlist) & Node.DOCUMENT_POSITION_FOLLOWING;
      return wishlistIsLater ? wishlist : buy;
    }
    return wishlist || buy;
  }

  function place() {
    var panel = document.querySelector('.product__trust');
    if (!panel) return;

    var media = document.querySelector('.product__media-wrapper');
    var anchor = infoAnchor();
    var wantsMobile = window.innerWidth < BREAKPOINT;

    if (wantsMobile) {
      if (!anchor || panel.previousElementSibling === anchor) return;
      anchor.insertAdjacentElement('afterend', panel);
    } else {
      if (!media || panel.parentElement === media) return;
      media.appendChild(panel);
    }
  }

  var pending;
  function onResize() {
    window.clearTimeout(pending);
    pending = window.setTimeout(place, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
  // Run again at load: the wishlist button is an app block, so on a slow
  // connection it can arrive after DOMContentLoaded and the anchor would
  // otherwise be decided without it. place() is idempotent.
  window.addEventListener('load', place);
  window.addEventListener('resize', onResize);
})();
